var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"int-card"},[_c('img',{attrs:{"src":require("assets/icons/exps/int.jpg")}}),_c('div',{staticClass:"copy"},[_c('div',{staticClass:"line"},[_vm._v("总榜排名")]),_c('div',{staticClass:"data"},[_c('span',{staticClass:"no"},[_vm._v("NO.")]),_c('span',{staticClass:"rank"},[_vm._v(_vm._s(_vm.rank))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }